import defaultState from "./state";

const main = (state = defaultState, action) => {
  switch (action.type) {
    case "MENU_NAVIGATION": {
      return Object.assign({}, state, {
        menuHoverIndex: action.hoverIndex != null ? action.hoverIndex : state.menuHoverIndex,
        menuActiveIndex: action.activeIndex != null ? action.activeIndex : state.menuActiveIndex,
        menuIsHovering: action.isHovering != null ? action.isHovering : state.menuIsHovering,
      });
    }
    case "OPEN_CLOSE_MODAL_GALLERY": {
      return Object.assign({}, state, {
        isOpenModalGallery: action.isOpen,
        galleryItems: action.gallery,
        galleryTitle: action.title,
      });
    }
    default:
      return state;
  }
};
export default main;
